import { defineComponent as _defineComponent } from 'vue'
import { Item } from '@/components/Layers/modal/types';
import { getThumbUrl } from '@/utils/imageUtils';

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalImportListItem',
  props: {
    item: null,
    preventAction: { type: Boolean }
  },
  emits: ["item-selected"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'item-selected', value: Item): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    item: Item;
    preventAction?: boolean;
};





const itemSelected = (item: Item) => {
    if (props.preventAction) return;
    emit('item-selected', item);
};

return { __sfc: true,props, emit, itemSelected, getThumbUrl }
}

})